/**
 * SocialLinkedinIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const SocialLinkedinIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      d="M21 21h-3.698v-6.3c0-1.726-.657-2.691-2.024-2.691-1.487 0-2.264 1.004-2.264 2.692V21H9.45V9h3.564v1.616s1.072-1.983 3.618-1.983S21 10.188 21 13.403zM5.198 7.429A2.206 2.206 0 0 1 3 5.214C3 3.992 3.984 3 5.198 3s2.197.992 2.197 2.214A2.206 2.206 0 0 1 5.198 7.43M3.358 21h3.716V9H3.357z"
      clipRule="evenodd"
    />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const SocialLinkedinIcon = makeIcon('SocialLinkedinIcon', SocialLinkedinIconSvg)
